import {Component} from 'react';
import {connect} from 'react-redux';
import {setCacheId, setFiltersUrl, socketConnected} from '../actions/SocketActions';
import {bindActionCreators} from 'redux';
import openSocket from 'socket.io-client';
import {addParameters} from '../actions/ParametersActions';
import {
    arrivalAirportsReceived,
    baggageReceived,
    cheapestFlightUpdate,
    flightDurationsReceived,
    flightsCountUpdated,
    flightsImportEnd,
    parentFiltersChanged,
    recommendedFlightUpdate,
    refreshFlights,
    returnAirportsReceived,
    setSelectedUrlFilters,
    socketFlightsFiltered,
    socketFlightsReceived,
    stopAirportsReceived,
    stopsReceived,
    toggleOverlay,
    transferTimeReceived,
    updateCarrierFilters
} from '../actions/FlightsActions';
import FilterEncoder from '../helpers/FilterEncoder';
import IframeHelper from '../helpers/IframeHelper';

class Socket extends Component {
    componentDidMount() {
        this.parameters = JSON.parse(this.props.dataParameters);
        this.props.addParameters(this.parameters);
        this.props.setCacheId(this.parameters.uid, this.parameters.code);

        this.socket = openSocket(this.parameters['flights-socket-server'], {
            secure: true,
            reconnect: true,
            query: `location=${encodeURIComponent(window.location.href)}`
        });
        this.socket.on('connect', () => {
            this.makeInitialFetch();
            this.props.socketConnected(this.socket);

        });
        this.registerSocketEvents();
        this.listenForParentFilterChanges();
    }

    makeInitialFetch() {
        let parameters = '';
        let stateParameters = this.parameters['search-params'];
        if (typeof stateParameters.arrivalAirport !== 'undefined') {
            delete stateParameters.arrivalCity;
        }

        if (typeof stateParameters.departureAirport !== 'undefined') {
            delete stateParameters.departureCity;
        }

        Object.keys(stateParameters).map((key) => {
            if ((key.indexOf('filter') !== 0) && (key.indexOf('wfilter') !== 0)) {
                parameters += `&${key}=${stateParameters[key]}`;
            }

            return true;
        });

        this.updateUrlSelectedFilters();

        fetch(`${this.parameters['results-provider']}?ck=${this.props.cacheId}&code=${this.props.code}&socketId=${this.socket.id}${parameters}`);
    }

    updateUrlSelectedFilters() {
        if (this.parameters['search-params']['filter']) {
            const filters = this.parameters['search-params']['filter'];
            Object.keys(filters).map((filter) => {
                this.props.setSelectedUrlFilters(filter, filters[filter]);

                return true;
            });
            this.props.setFiltersUrl(filters);
        }
    }

    registerSocketEvents() {
        this.socket.on('flights-results', () => {
            this.props.socketFlightsReceived();
        });

        this.socket.on('flights-results-filter-response', (data) => {
            this.props.socketFlightsFiltered(data);
            data.filters.carriers && this.props.updateCarrierFilters(data.filters.carriers);
            data.filters.durations && this.props.flightDurationsReceived(data.filters.durations);
            data.filters.arrivalAirports && this.props.arrivalAirportsReceived(data.filters.arrivalAirports);
            data.filters.returnAirports && this.props.returnAirportsReceived(data.filters.returnAirports);
            data.filters.stopAirports && this.props.stopAirportsReceived(data.filters.stopAirports);
            data.filters.freeBaggage && this.props.baggageReceived(data.filters.freeBaggage);
            data.filters.maxStops && this.props.stopsReceived(data.filters.maxStops);
            data.filters.flightsCount && this.props.flightsCountUpdated(data.filters.flightsCount);
            data.filters.cheapest && this.props.cheapestFlightUpdate(data.filters.cheapest);
            data.filters.transferTime && this.props.transferTimeReceived(data.filters.transferTime);
            data.filters.recommended && this.props.recommendedFlightUpdate(data.filters.recommended);
        });
        this.socket.on('flights-results-filter-refresh', () => {
            this.props.toggleOverlay(true);
            this.props.refreshFlights();
            this.makeInitialFetch();
        });

        this.socket.on('flights-import-end', (data) => this.props.flightsImportEnd(data));
    }

    render() {
        return null;
    }

    listenForParentFilterChanges() {
        const self = this;
        if (IframeHelper.isInIframe() && !this.messageBusInited) {
            this.messageBusInited = true;
            window.ComponentsMessageBus.recieveMessage(function (msg) {
                if (
                    typeof (msg.type) === 'undefined' ||
                    msg.type !== 'filters' || msg.filters === 'null'
                ) {
                    return false;
                }

                const urlParameters = FilterEncoder.decode(msg.filters);
                self.props.parentFiltersChanged(urlParameters.search, urlParameters.filters, msg.firstRequest);
            }, true);
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addParameters,
        socketConnected,
        socketFlightsReceived,
        updateCarrierFilters,
        socketFlightsFiltered,
        arrivalAirportsReceived,
        returnAirportsReceived,
        stopAirportsReceived,
        baggageReceived,
        stopsReceived,
        setCacheId,
        flightsCountUpdated,
        flightDurationsReceived,
        setSelectedUrlFilters,
        flightsImportEnd,
        setFiltersUrl,
        cheapestFlightUpdate,
        recommendedFlightUpdate,
        parentFiltersChanged,
        toggleOverlay,
        refreshFlights,
        transferTimeReceived
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        dataParameters: ownProps.parameters,
        parameters: state.ParametersReducer.parameters,
        urlFilters: state.SocketReducer.urlFilters,
        cacheId: state.SocketReducer.cacheId,
        code: state.SocketReducer.code
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Socket);



// WEBPACK FOOTER //
// ./src/components/Socket.js